import React from "react";
import { PrimaryButton } from "@fluentui/react";

type GradientButtonType = {
  text: string;
  icon?: string;
  onClick: () => void;
};

export const GradientButton = ({ icon, text, onClick }: GradientButtonType) => {
  return (
    <PrimaryButton
      text={text}
      onClick={onClick}
      iconProps={{
        iconName: icon,
      }}
      styles={{
        root: {
          background: "linear-gradient(to right, #34d2f6, #8e54e9)",
          color: "white",
          border: "none",
          borderRadius: "4px",
          padding: "0 24px",
          height: "32px",
          fontWeight: 500,
        },
        rootHovered: {
          filter: "brightness(1.1)",
        },
        rootPressed: {
          filter: "brightness(0.9)",
        },
      }}
    />
  );
};
